import { Divider } from "@material-ui/core";
import { usePopup } from "hooks/usePopup";
import { useEffect, useState } from "react";
import { HiOutlineCheck, HiOutlineClock, HiOutlineTruck } from "react-icons/hi";
import batchService from "services/batchService";

import { formatData } from "../../../utils/formatData";
import { CardTitle, CardValue, IconContent, InfoContent } from "../styles";
import { CardContent } from "./CardContent";
import {
  CardsContainer,
  LastUpdatedCard,
  SupplierStatusPanel,
  SupplierStatusTitle
} from "./styles";

export const VertDashCards = () => {
  const { addPopup } = usePopup();
  const [batchSellerPendingData, setBatchSellerPendingData] = useState({});
  const [batchSellerReceiptData, setBatchSellerReceiptData] = useState({});
  const [loadingSellerPending, setLoadingSellerPending] = useState(false);
  const [loadingSellerReceipt, setLoadingSellerReceipt] = useState(false);
  const [lastUpdated, setLastUpdated] = useState();

  const getBatchSellerPending = async () => {
    try {
      setLoadingSellerPending(true);
      const params = {
        status: 1,
        pageSize: 1000
      };
      const { data } = await batchService.getSellerBatches(params);
      const formattedData = formatData.formatSellerPendingData(data.results);
      setBatchSellerPendingData(formattedData);
    } catch (error) {
      const errorMessage = error?.response?.data?.msg;
      addPopup({
        type: "error",
        title: "Erro ao carregar lotes",
        description: errorMessage
      });
    } finally {
      setLoadingSellerPending(false);
    }
  };

  const getBatchSellerReceipt = async () => {
    try {
      const toDayDate = new Date();
      setLoadingSellerReceipt(true);
      const params = {
        status: 2,
        receiptDateFrom: new Date(toDayDate.setHours(0, 0, 0, 1)),
        receiptDateTo: new Date(toDayDate.setHours(23, 59, 59, 0)),
        pageSize: 1000
      };
      const { data } = await batchService.getSellerBatches(params);
      const formattedData = formatData.formatSellerReceiptData(data.results);
      setBatchSellerReceiptData(formattedData);
    } catch (error) {
      const errorMessage = error?.response?.data?.msg;
      addPopup({
        type: "error",
        title: "Erro ao carregar lotes",
        description: errorMessage
      });
    } finally {
      setLoadingSellerReceipt(false);
    }
  };

  const getLastUpdated = () => {
    setLastUpdated(new Date().toLocaleTimeString("pt-BR", { hour12: false }));
  };

  useEffect(() => {
    getBatchSellerPending();
    getBatchSellerReceipt();
    getLastUpdated();
  }, []);

  return (
    <CardsContainer gridArea="side">
      <SupplierStatusPanel>
        <SupplierStatusTitle>Situação de fornecedores</SupplierStatusTitle>

        <CardContent loading={loadingSellerPending}>
          <IconContent style={{ background: "#E8F6DD" }}>
            <HiOutlineTruck size={17} color="#416D0B" />
          </IconContent>
          <InfoContent>
            <CardValue>
              {batchSellerPendingData.suppliersReceivable ?? 0}
            </CardValue>
            <CardTitle>Fornecedores a receber</CardTitle>
          </InfoContent>
        </CardContent>

        <Divider />

        <CardContent loading={loadingSellerPending}>
          <IconContent style={{ background: "#FFF4E5" }}>
            <HiOutlineClock size={17} color="#FB8C00" />
          </IconContent>
          <InfoContent>
            <CardValue>
              {batchSellerPendingData.suppliersPending ?? 0}
            </CardValue>
            <CardTitle>Fornecedores em andamento</CardTitle>
          </InfoContent>
        </CardContent>

        <Divider />

        <CardContent loading={loadingSellerReceipt}>
          <IconContent style={{ background: "#E8F6DD" }}>
            <HiOutlineCheck size={17} color="#27A844" />
          </IconContent>
          <InfoContent>
            <CardValue>
              {batchSellerReceiptData.finalizedSuppliers ?? 0}
            </CardValue>
            <CardTitle>Fornecedores finalizados</CardTitle>
          </InfoContent>
        </CardContent>
      </SupplierStatusPanel>

      <LastUpdatedCard>
        <IconContent style={{ background: "#E8F6DD" }}>
          <HiOutlineClock size={17} color="#416D0B" />
        </IconContent>
        <InfoContent>
          <CardTitle>Última atualização</CardTitle>
          <CardValue>{lastUpdated}</CardValue>
        </InfoContent>
      </LastUpdatedCard>
    </CardsContainer>
  );
};
